import { use } from "react";
import { ColorModeContext } from "../../contexts/color-mode";
import logoBlack from "@loopress/assets/loopress-logo-black.svg";
import logoWhite from "@loopress/assets/loopress-logo-white.svg";


export const Title = ({ collapsed }: { collapsed: boolean }) => {
  const { mode } = use(ColorModeContext);
  const color = mode === "dark" ? "#FFFFFF" : "#0A0A0A";

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        gap: 8,
        padding: "12px 16px",
        overflow: "hidden",
      }}
    >
      <img src={mode === "light" ? logoBlack : logoWhite} height={28} />

      {!collapsed && (
        <span style={{ display: "flex", alignItems: "center", gap: 6, whiteSpace: "nowrap" }}>
          <span style={{ fontWeight: 600, fontSize: 15, color }}>Loopress</span>
          <span
            style={{
              fontSize: 10,
              fontWeight: 600,
              lineHeight: 1,
              padding: "2px 5px",
              borderRadius: 4,
              background: "#f0f0f0",
              color: "#888",
              letterSpacing: "0.03em",
            }}
          >
            ALPHA
          </span>
        </span>
      )}
    </div>
  );
};
